import { useRef, useEffect, useCallback } from "react";
import throttle from "lodash/throttle";

export function useThrottle(cb, delay, leading = true, trailing = false) {
	const options = { leading, trailing }; // add custom lodash options
	const cbRef = useRef(cb);
	// use mutable ref to make useCallback/throttle not depend on `cb` dep
	useEffect(() => {
		cbRef.current = cb;
	});
	return useCallback(
		throttle((...args) => cbRef.current(...args), delay, options),
		[delay]
	);
}
